import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {EvaluateDayEvent} from "@/modules/season/events/EvaluateDayEvent";
import {inject, injectable} from "inversify";
import MatchdayEvaluator from "@/modules/competitions/services/evaluators/MatchdayEvaluator";
import {Matchday} from "@/modules/competitions/entity";
import {FindManyOptions, LessThanOrEqual} from "typeorm";
import {Application} from "@/di";

@injectable()
export class MatchdayEvaluationEventSubscriber implements EventSubscriber {
  constructor(
    @inject(Application) private app: Application,
    @inject(MatchdayEvaluator) private matchdayEvaluator: MatchdayEvaluator,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: EvaluateDayEvent, callback: this.onEvaluateDay},
    ];
  }

  async onEvaluateDay(event: EvaluateDayEvent): Promise<void> {
    const matchdays = await Matchday.find({
      where: {
        finished: false,
        scheduledAt: LessThanOrEqual(
          event.season.currentDate.endOf('day').toDate(),
        ),
        season: {
          id: event.season.id,
        },
      },
      relations: {
        season: true,
      }
    } as FindManyOptions);

    if (matchdays) {
      await matchdays.forEachAsync((matchday: Matchday) => this.matchdayEvaluator.evaluate(matchday));
    }
  }
}